import { Component, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { ActivatedRoute, Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { environment } from '../../../../../environments/environment'
import { PaginationComponent } from '../../template/pagination/pagination.component'
import { CapitalizePipe } from '../../../../pipes/capitalize.pipe'
import { CommonModule, NgFor, NgIf, NgIfContext } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { combineLatest, filter, map, Observable, of, Subject, take, takeUntil, tap } from 'rxjs'
import { eps } from '../../../../services/url.service'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { loadEmployees } from '../../../../store/user/user.actions'
import { selectUsers } from '../../../../store/user/user.reducer'
import { User } from '../../../../store/auth/auth.state'
import { Actions, ofType } from '@ngrx/effects'
import { LoaderComponent } from '../../../../shared/components/loader/loader.component'
import { Role } from '../../../../store/role/role.state'
import { selectRoleDetail, selectUnassignedUsers } from '../../../../store/role/role.selectors'
import {
  createAssignedTo,
  deleteAssignedTo,
  loadAssignedTo,
  loadAssignedToSuccess,
  loadRoleById,
  loadRoleByIdSuccess,
  loadUnassignedUsers,
  upsertValidUpto
} from '../../../../store/role/role.actions'
import { selectAssignedTo } from '../../../../store/role/role.reducer'
import { selectUser } from '../../../../store/auth/auth.selectors'
import { HasPermissionDirective } from '../../../../directives/has-permission.directive'
import { SharedModule } from '../../../../shared/shared.module'
import { Business } from '../../../../store/business/business.state'
import { selectAllBusinesses } from '../../../../store/business/business.selectors'
import { NgSelectModule } from '@ng-select/ng-select'
import { loadBusinesses } from '../../../../store/business/business.actions'
import {
  createAssignedToSuccess,
  deleteAssignedToSuccess
} from '../../../../store/role-permission/role-permission.actions'
import { DeleteComponent } from '../../template/delete/delete.component'
import { clearUnassignedUsers } from '../../../../store/permission-sets/permission-sets.actions'

interface ExtendedUser extends User {
  validUpto: string | null
}

@Component({
  selector: 'app-details',
  imports: [
    NgIf,
    NgFor,
    RouterModule,
    FormsModule,
    CommonModule,
    CapitalizePipe,
    // PaginationComponent,
    LoaderComponent,
    HasPermissionDirective,
    SharedModule,
    PaginationComponent,
    NgSelectModule
  ],
  templateUrl: './role-detail.component.html',
  styleUrl: './role-detail.component.scss'
})
export class RoleDetailComponent implements OnInit, OnDestroy {
  private store = inject(Store)
  private route = inject(ActivatedRoute)
  private router = inject(Router)
  private modalService = inject(NgbModal)
  eps = eps
  roleId!: string
  destroy$ = new Subject<void>()
  assignedTo$ = this.store.select(selectAssignedTo)
  // allUsers$ = this.store.select(selectUsers)
  // unassignedUsers$!: Observable<ExtendedUser[]>
  // unassignedUsers$ = this.store.select(selectUnassignedUsers)
  // unassignedUsers$ = combineLatest([
  //   this.store.select(selectUnassignedUsers),
  //   this.store.select(selectAssignedTo)
  // ]).pipe(
  //   map(([unassignedUsers, assignedTo]) => {
  //     if (!this.businessId) return []
  //     const assignedIds = new Set((assignedTo ?? []).map(a => a.user?.id).filter(Boolean))
  //     return (unassignedUsers ?? []).filter(user => !assignedIds.has(user.id))
  //   })
  // )

  unassignedUsers$ = combineLatest([
    this.store.select(selectUnassignedUsers),
    this.store.select(selectAssignedTo)
  ]).pipe(
    map(([unassignedUsers, assignedTo]) => {
      // if (!this.businessIdtoAssign) return unassignedUsers ?? []

      // if (!this.businessId || !this.businessIdtoAssign) {
      //   return []
      // }

      if (!this.businessId) {
        return []
      }

      // const assignedKeys = new Set(
      //   (assignedTo ?? [])
      //     .filter(a => a.business?.id === this.businessIdtoAssign)
      //     .map(a => `${a.user?.id}-${a.business?.id}`)
      // )

      // const assignedKeys = new Set(
      //   (assignedTo ?? [])
      //     .filter(a => !this.businessIdtoAssign || a.business?.id === this.businessIdtoAssign)
      //     .map(a => `${a.user?.id}-${a.business?.id}`)
      // )

      // return (unassignedUsers ?? []).filter(
      //   user => !assignedKeys.has(`${user.id}-${this.businessIdtoAssign}`)
      // )

      // const assignedIds = new Set((assignedTo ?? []).map(a => a.user?.id).filter(Boolean))

      // return (unassignedUsers ?? []).filter(user => !assignedIds.has(user.id))
      return unassignedUsers ?? []
    })
  )

  idForValidUptoUpdate = ''
  TempValidUpto!: Date | null
  selectedUsers: ExtendedUser[] = []

  totalCount = 0
  currentPage = 1
  pageLimit = 10
  search: string = ''
  order = 'desc'
  pageLastRecord = 0
  defaultImg = '../../../../assets/img/user.jpg'
  apiEndpoint = environment.apiBaseUrl
  role$: Observable<Role | undefined> = of(undefined) // Initialize with a default value
  @ViewChild('assignUsersModal') assignUsersModal!: TemplateRef<any>
  searchText = ''
  user: User | null = null
  businesses$: Observable<Business[]> = this.store.select(selectAllBusinesses)
  businessId: string | null = null
  businessIdtoAssign: string | null = null
  roleIsStandard = false
  noRecords!: TemplateRef<NgIfContext<boolean>> | null
  loading!: TemplateRef<NgIfContext<Role | null | undefined>> | null
  initials!: TemplateRef<NgIfContext<string | null>> | null
  status = false

  constructor(private actions$: Actions) {
    // const roleId = this.route.snapshot.paramMap.get('id')
    // if (!roleId) this.router.navigate([eps.userRole.rolePath])
    // this.roleId = Number(roleId)
    // this.store.dispatch(loadRoleById({ id: this.roleId }))
    // this.role$ = this.store.select(selectRoleDetail)
  }

  assignedEmployees: any[] = [] // current page data
  allAssignedEmployees: any[] = []

  noEmployee: any
  ngOnInit(): void {
    const roleId = this.route.snapshot.paramMap.get('id')
    if (!roleId) this.router.navigate([eps.userRole.rolePath])
    if (roleId) {
      this.roleId = roleId
    }
    this.store.dispatch(loadRoleById({ id: this.roleId }))
    this.role$ = this.store.select(selectRoleDetail)

    // this.store.dispatch(loadAssignedTo({ roleId: this.roleId }))
    this.loadAssignedTo()
    // this.store.dispatch(loadEmployees({}))

    this.store
      .select(selectUser)
      .pipe(take(1))
      .subscribe(user => {
        this.user = user
      })
    // this.unassignedUsers$.subscribe(res => {
    //   console.log('Unassigned Users:', res)
    // })

    // this.unassignedUsers$ = combineLatest([this.allUsers$, this.assignedTo$]).pipe(
    //   map(([allUsers, assignedUsers]) => {
    //     const assignedList = assignedUsers ?? []
    //     // const assignedIds = new Set(assignedList.map(u => u.user.id))
    //     const assignedIds = new Set(assignedList.filter(u => u?.user?.id).map(u => u.user.id))

    //     //Create a date 30 days ahead of now
    //     const validUptoDefault = this.getFormattedDate(
    //       new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
    //     )
    //     return allUsers
    //       .filter(user => !assignedIds.has(user.id))
    //       .map(user => ({
    //         ...user,
    //         validUpto: validUptoDefault
    //       }))
    //   })
    // )

    // this.assignedTo$.pipe(takeUntil(this.destroy$)).subscribe(d => {
    //   this.totalCount = d?.length ?? 0
    //   this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, this.totalCount)
    // })

    // this code is add by shivam
    // this.assignedTo$.pipe(takeUntil(this.destroy$)).subscribe(d => {
    //   const list = d ?? []

    //   // ✅ IMPORTANT: store data
    //   this.allAssignedEmployees = list
    //   this.assignedEmployees = list.slice(0, this.pageLimit)

    //   this.totalCount = list.length
    //   this.pageLastRecord = Math.min(this.pageLimit, this.totalCount)
    // })

    // this.assignedTo$.pipe(takeUntil(this.destroy$)).subscribe(d => {
    //   const list = d ?? []
    //   this.allAssignedEmployees = list

    //   const filtered = this.search
    //     ? list.filter(item =>
    //         `${item.user?.firstName || ''} ${item.user?.lastName || ''}`
    //           .toLowerCase()
    //           .includes(this.search.toLowerCase())
    //       )
    //     : list

    //   this.totalCount = filtered.length

    //   const maxPage = Math.ceil(filtered.length / this.pageLimit) || 1
    //   if (this.currentPage > maxPage) {
    //     this.currentPage = maxPage
    //   }

    //   const start = (this.currentPage - 1) * this.pageLimit
    //   const end = start + this.pageLimit

    //   this.assignedEmployees = filtered.slice(start, end)
    //   this.pageLastRecord = Math.min(end, filtered.length)
    // })

    this.actions$
      .pipe(ofType(loadAssignedToSuccess), takeUntil(this.destroy$))
      .subscribe(({ assignedTo, totalCount }) => {
        this.assignedEmployees = assignedTo
        this.allAssignedEmployees = assignedTo
        this.totalCount = totalCount
        this.pageLastRecord = Math.min(this.currentPage * this.pageLimit, totalCount)
        // this.pageLastRecord = this.pageLimit
      })

    // 👇 Wait for loadRoleByIdSuccess before selecting role
    this.actions$
      .pipe(
        ofType(loadRoleByIdSuccess),
        take(1),
        tap(({ role }) => {
          this.roleIsStandard = role.isStandard
          if (
            role?.businessId &&
            role.name !== 'Employee' &&
            role.name !== 'Contractor' &&
            role.name !== 'Trainee' &&
            !this.isAdmin
          ) {
            this.store.dispatch(
              loadEmployees({
                params: new URLSearchParams({ businessId: role.businessId }).toString()
              })
            )
          } else {
            this.store.dispatch(loadEmployees({}))
          }
          // this.store.dispatch(loadEmployees({}))
        })
      )
      .subscribe()

    this.businesses$
      .pipe(take(1)) // sirf ek baar check karega
      .subscribe(businesses => {
        if (!businesses || businesses.length === 0) {
          this.store.dispatch(loadBusinesses({ params: null }))
        }
      })

    // this.actions$.pipe(ofType(createAssignedToSuccess), takeUntil(this.destroy$)).subscribe(() => {
    //   this.store.dispatch(clearUnassignedUsers())
    //   this.store.dispatch(
    //     loadUnassignedUsers({
    //       roleId: this.roleId,
    //       businessId: this.businessId,
    //       businessIdtoAssign: this.businessIdtoAssign
    //     })
    //   )
    // })
    this.actions$.pipe(ofType(createAssignedToSuccess), takeUntil(this.destroy$)).subscribe(() => {
      this.loadAssignedTo()
      this.store.dispatch(clearUnassignedUsers())
      if (this.businessId) {
        this.store.dispatch(
          loadUnassignedUsers({
            roleId: this.roleId,
            businessId: this.businessId,
            businessIdtoAssign: this.businessIdtoAssign
          })
        )
      }
    })
  }
  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

  //Left this function from past to get the skip value for when setting pagination
  getAssignedEmployeeList() {
    //const skip = this.currentPage * this.pageLimit - this.pageLimit
  }

  pageChanged(page: number) {
    this.currentPage = page
    this.getAssignedEmployeeList()
  }

  getFormattedDate(date: string | null) {
    if (!date) return null
    return new Date(date).toISOString().slice(0, 10) // Just YYYY-MM-DD
  }

  //---Editing Assigned Users---
  editValidUpto(id: string) {
    this.idForValidUptoUpdate = id
  }

  // this code is added by shivam
  // onSearchEmployee() {
  //   const term = this.search?.toLowerCase().trim() || ''

  //   // ✅ always filter from ORIGINAL data
  //   let filtered = this.allAssignedEmployees.filter(item => item?.user)

  //   if (term) {
  //     filtered = filtered.filter(item => {
  //       const name = `${item.user.firstName} ${item.user.lastName}`.toLowerCase()
  //       return name.includes(term)
  //     })
  //   }

  //   this.noEmployee = term.length > 0 && filtered.length === 0

  //   // ✅ update UI
  //   this.totalCount = filtered.length
  //   this.currentPage = 1

  //   this.assignedEmployees = filtered.slice(0, this.pageLimit)
  // }

  saveValidUpto() {
    this.store.dispatch(
      upsertValidUpto({ id: this.idForValidUptoUpdate, validUpto: this.TempValidUpto })
    )
    this.idForValidUptoUpdate = ''
    this.TempValidUpto = null
  }

  deleteAssignment(id: string) {
    this.store.dispatch(deleteAssignedTo({ id }))
  }
  //---Editing Assigned Users Ends---

  //---Assigning Users---
  openModel(modal: unknown) {
    this.searchText = ''
    this.selectedUsers = []
    this.businessId = null
    this.businessIdtoAssign = null
    this.store.dispatch(clearUnassignedUsers())
    this.modalService.open(modal, {
      scrollable: false,
      centered: true,
      size: 'md'
    })
    // this.onIsStandardChange()
  }

  onPageChange(page: number) {
    this.currentPage = page
    // this.updatePaginatedData()
    this.loadAssignedTo()
  }

  updatePaginatedData() {
    const source = this.search
      ? this.allAssignedEmployees.filter(item =>
          `${item.user?.firstName || ''} ${item.user?.lastName || ''}`
            .toLowerCase()
            .includes(this.search.toLowerCase())
        )
      : this.allAssignedEmployees

    const start = (this.currentPage - 1) * this.pageLimit
    const end = start + this.pageLimit

    this.assignedEmployees = source.slice(start, end)
    this.pageLastRecord = Math.min(end, source.length)
  }
  onClose() {
    this.searchText = '' // Reset search box
    this.selectedUsers = [] // Clear selected users
    this.businessId = null
    this.businessIdtoAssign = null
    this.store.dispatch(clearUnassignedUsers())
    this.getAssignedEmployeeList()
    this.modalService.dismissAll()
  }

  toggleSelection(user: ExtendedUser) {
    const index = this.selectedUsers.findIndex(u => u.id === user.id)
    if (index === -1) this.selectedUsers.push(user)
    else this.selectedUsers.splice(index, 1)
  }

  // saveAssignedUsers() {
  //   const userData = this.selectedUsers.map(u => ({ userId: u.id, validUpto: u.validUpto }))
  //   this.store.dispatch(
  //     createAssignedTo({
  //       roleId: this.roleId,
  //       userData,
  //       // businessId: this.businessIdtoAssign
  //       businessId: this.roleIsStandard ? this.businessIdtoAssign : (this.user?.businessId ?? null)
  //     })
  //   )
  //   this.onClose()
  // }

  saveAssignedUsers() {
    const userData = this.selectedUsers.map(u => ({
      userId: u.id,
      validUpto: u.validUpto
    }))

    const businessId =
      this.businessIdtoAssign || this.user?.businessId || this.selectedUsers[0]?.businessId // ✅ fallback

    if (!businessId) {
      console.error('❌ BusinessId is missing')
      return
    }

    this.store.dispatch(
      createAssignedTo({
        roleId: this.roleId,
        userData,
        businessId
      })
    )

    this.onClose()
  }

  filteredUsers(users: any[]): any[] {
    if (!this.searchText) {
      return users
    }
    const lowerSearch = this.searchText.toLowerCase()
    return users.filter(user => user.firstName?.toLowerCase().includes(lowerSearch))
  }

  getInitials(firstName: string = '', lastName: string = ''): string {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  isAdmin(): boolean {
    // return this.user?.role === 'Admin'
    return this.user?.userRoles?.some((ur: any) => ur.role?.name === 'Admin') ?? false
  }

  onIsStandardChange() {
    // this.currentPage = 1 // Reset to the first page on search
    // this.loadRoles()
    if (!this.businessId) {
      this.store.dispatch(clearUnassignedUsers())
      return
    }
    this.store.dispatch(
      loadUnassignedUsers({
        roleId: this.roleId,
        businessId: this.businessId,
        businessIdtoAssign: this.businessIdtoAssign
      })
    )
  }

  customSearchFn = (term: string, item: any) => {
    const fullName = `${item.businessName}`.toLowerCase()
    return fullName.includes(term.toLowerCase())
  }

  openDeleteModal(employeeId: string) {
    const modalRef = this.modalService.open(DeleteComponent)
    modalRef.componentInstance.recordId = employeeId
    modalRef.result.then(
      result => {
        // Handle the result from the modal
        if (result) {
          // Call the service to update the business status
          this.handleDeleteConfirm(result)
        }
      },
      reason => {
        // Handle the dismiss case
        if (reason) {
          this.handleDeleteConfirm(reason)
        }
      }
    )
  }

  handleDeleteConfirm(data: { id: string }) {
    this.store.dispatch(deleteAssignedTo({ id: data.id }))
    this.actions$.pipe(ofType(deleteAssignedToSuccess), take(1)).subscribe(() => {
      // this.store.dispatch(loadAssignedTo({ roleId: this.roleId }))
      this.loadAssignedTo()
    })
  }

  loadAssignedTo() {
    const params: any = {}

    // params.disabled = this.status
    if (params.status !== '') {
      params.disabled = this.status
    }

    if (this.businessId) {
      params.businessId = this.businessId
    }

    if (this.search) {
      params.search = this.search
    }

    this.store.dispatch(
      loadAssignedTo({
        roleId: this.roleId,
        params: new URLSearchParams(params).toString(),
        page: this.currentPage,
        limit: this.pageLimit
      })
    )
  }

  setCurrentPage() {
    this.currentPage = 1
  }

  onPageLimitChange() {
    this.currentPage = 1 // Reset to first page when limit changes
    this.loadAssignedTo() // Load employees with new page limit
  }

  onSearch() {
    this.currentPage = 1 // Reset to the first page on search
    this.loadAssignedTo()
  }

  // compareBusiness(b1: any, b2: any): boolean {
  //   return b1 === b2
  // }

  //---Assigning Users Ends---
}
